const Home = () => {
  return (
    <div className="p-5">
      <h1 className="text-4xl">Home</h1>
    </div>
  );
};

export default Home;
